var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.50008V10.0001C12.5 10.9167 11.75 11.6667 10.8333 11.6667H1.66666V5.00008C1.66666 3.15841 3.15833 1.66675 5 1.66675H11.6667C12.125 1.66675 12.5 2.04175 12.5 2.50008Z",
    fill: "#838B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 11.6667V14.1667C18.3333 15.5501 17.2167 16.6667 15.8333 16.6667H15C15 15.7501 14.25 15.0001 13.3333 15.0001C12.4167 15.0001 11.6667 15.7501 11.6667 16.6667H8.33333C8.33333 15.7501 7.58333 15.0001 6.66666 15.0001C5.75 15.0001 5 15.7501 5 16.6667H4.16666C2.78333 16.6667 1.66666 15.5501 1.66666 14.1667V11.6667H10.8333C11.75 11.6667 12.5 10.9167 12.5 10.0001V4.16675H14.0333C14.6333 4.16675 15.1833 4.49176 15.4833 5.00842L16.9083 7.50008H15.8333C15.375 7.50008 15 7.87508 15 8.33341V10.8334C15 11.2917 15.375 11.6667 15.8333 11.6667H18.3333Z",
    fill: "#CCCFD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 18.3333C7.58714 18.3333 8.33333 17.5871 8.33333 16.6667C8.33333 15.7462 7.58714 15 6.66667 15C5.74619 15 5 15.7462 5 16.6667C5 17.5871 5.74619 18.3333 6.66667 18.3333Z",
    fill: "#838B9B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 18.3333C14.2538 18.3333 15 17.5871 15 16.6667C15 15.7462 14.2538 15 13.3333 15C12.4129 15 11.6667 15.7462 11.6667 16.6667C11.6667 17.5871 12.4129 18.3333 13.3333 18.3333Z",
    fill: "#838B9B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.4417V11.6667H15.8333C15.375 11.6667 15 11.2917 15 10.8333V8.33333C15 7.875 15.375 7.5 15.8333 7.5H16.9083L18.1167 9.61665C18.2583 9.86665 18.3333 10.15 18.3333 10.4417Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.d612f82569a72bb69a8efcb7500bc481.svg";
export { ForwardRef as ReactComponent };